<template>
  <div class="profile-wrapper" :style="{
      transform: 'scale(' + $store.state.scale + ')',
      transformOrigin: 'top center',
      maxWidth:
        $route.params.type == 'kare-okuma' ||
        $route.params.type == 'siir' ||
        $route.params.type == 'tekerleme' ||
        $route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
        $route.params.type == 'ileri-seviye-kare-okuma' ||
        $route.params.type == 'ileri-seviye-siir' ||
        $route.params.type == 'takistoskop' ||
        $route.params.type == 'kelime-egzersizi' ||
        $route.params.type == 'heceleme' ||
        $route.params.type == 'metin-okuma' ||
        $route.params.type == 'ileri-seviye-tekerleme' ||
        $route.params.type == 'odak-okuma'
          ? '100%'
          : '',
    }">
    <GozEsnetme v-if="start == true && $route.params.type == 'goz-esnetme'"></GozEsnetme>
    <IkiliUcluBlok v-if="start == true && $route.params.type == 'ikili-uclu-blok'"></IkiliUcluBlok>
    <EsnekGormeAlani v-if="start == true && $route.params.type == 'esnek-gorme-alani'"></EsnekGormeAlani>
    <GozEsnekligi v-if="start == true && $route.params.type == 'goz-esnekligi'"></GozEsnekligi>
    <GozRitim v-if="start == true && $route.params.type == 'goz-ritim'"></GozRitim>

    <AcilanNesnelerYatay direction="horizontal" v-if="start == true && $route.params.type == 'acilan-nesneler-yatay'">
    </AcilanNesnelerYatay>
    <KareGormeAlani direction="vertical" v-if="start == true && $route.params.type == 'kare-gorme-alani'">
    </KareGormeAlani>
    <HarfSayma v-if="start == true && $route.params.type == 'harf-sayma'"></HarfSayma>
    <FarkliOlan v-if="start == true && $route.params.type == 'farkli-olan'"></FarkliOlan>
    <KelimeAvi v-if="start == true && $route.params.type == 'kelime-avi'"></KelimeAvi>
    <CokluFokus v-if="start == true && $route.params.type == 'coklu-fokus'"></CokluFokus>
    <CevreFokus v-if="start == true && $route.params.type == 'cevre-fokus'"></CevreFokus>
    <BlokOkuma v-if="start == true && $route.params.type == 'blok-okuma'"></BlokOkuma>
    <GolgeliOkuma v-if="start == true && $route.params.type == 'golgeli-okuma'"></GolgeliOkuma>
    <GrupOkuma v-if="start == true && $route.params.type == 'grup-okuma'"></GrupOkuma>
    <Takistoskop v-if="start == true && $route.params.type == 'takistoskop'"></Takistoskop>
    <ZikZak v-if="start == true && $route.params.type == 'zikzak'"></ZikZak>
    <BenzerKelimeler v-if="start == true && $route.params.type == 'benzer-kelimeler'"></BenzerKelimeler>
    <DuzeltBakalim v-if="start == true && $route.params.type == 'duzelt-bakalim'"></DuzeltBakalim>
    <Siralama v-if="start == true && $route.params.type == 'siralama'"></Siralama>
    <EsAnlamlilar v-if="start == true && $route.params.type == 'es-anlamlilar'"></EsAnlamlilar>
    <HangisiBuyuk v-if="start == true && $route.params.type == 'hangisi-buyuk'"></HangisiBuyuk>
    <HizliSecim v-if="start == true && $route.params.type == 'hizli-secim'"></HizliSecim>
    <KostebegiYakala v-if="start == true && $route.params.type == 'kostebegi-yakala'"></KostebegiYakala>
    <HafizandaTut v-if="start == true && $route.params.type == 'hafiza-ucgeni'"></HafizandaTut>
    <HafizaKareleri v-if="start == true && $route.params.type == 'hafiza-kareleri'"></HafizaKareleri>
    <HafizaKareleri :rotate="true" v-if="start == true && $route.params.type == 'donen-hafiza'"></HafizaKareleri>
    <SpeedTest v-if="start == true && $route.params.type == 'speed-test'"></SpeedTest>
    <ForChild v-if="start == true && $route.params.type == 'kare-okuma'"></ForChild>
    <ForChildWord v-if="start == true && $route.params.type == 'ileri-seviye-kare-okuma'"></ForChildWord>
    <Siir v-if="start == true && $route.params.type == 'siir'"></Siir>
    <SiirWord v-if="start == true && $route.params.type == 'ileri-seviye-siir'"></SiirWord>
    <Tekerleme v-if="start == true && $route.params.type == 'tekerleme'"></Tekerleme>
    <TekerlemeWord v-if="start == true && $route.params.type == 'ileri-seviye-tekerleme'"></TekerlemeWord>
    <DuzeltBakalimKids v-if="
        start == true && $route.params.type == 'duzelt-bakalim-cocuklar-icin'
      "></DuzeltBakalimKids>
    <Heceleme v-if="start == true && $route.params.type == 'heceleme'"></Heceleme>
    <MetinOkuma v-if="start == true && $route.params.type == 'metin-okuma'"></MetinOkuma>
    <KelimeEgzersizi v-if="start == true && $route.params.type == 'kelime-egzersizi'"></KelimeEgzersizi>
    <Bavul v-if="start == true && $route.params.type == 'bavul'"></Bavul>
    <KarTanesi v-if="start == true && $route.params.type == 'kar-tanesi'"></KarTanesi>
    <HarfSaymaDev v-if="start == true && $route.params.type == 'harf-sayma-dev'"></HarfSaymaDev>
    <HizliSecimTriple v-if="start == true && $route.params.type == 'hizli-secim-triple'"></HizliSecimTriple>
    <Tangram v-if="start == true && $route.params.type == 'tangram'"></Tangram>
    <SoruEgzersizi v-if="start == true && $route.params.type == 'soru-egzersizi'"></SoruEgzersizi>
    <SinavGolgeliOkuma v-if="start == true && $route.params.type == 'sinav-golgeli-okuma'"></SinavGolgeliOkuma>
    <SinavIkiliUcluBlok v-if="start == true && $route.params.type == 'sinav-ikili-uclu-blok'"></SinavIkiliUcluBlok>
    <SinavGozRitim v-if="start == true && $route.params.type == 'sinav-goz-ritim'"></SinavGozRitim>
    <SinavKelimeAvi v-if="start == true && $route.params.type == 'sinav-kelime-avi'"></SinavKelimeAvi>
    <SinavSerbestOkuma v-if="start == true && $route.params.type == 'sinav-metin-okuma'"></SinavSerbestOkuma>
    <OdakOkuma v-if="start == true && $route.params.type == 'odak-okuma'"></OdakOkuma>
    <JobGozRitim v-if="start == true && $route.params.type == 'job-goz-ritim'"></JobGozRitim>
    <JobGolgeliOkuma v-if="start == true && $route.params.type == 'job-golgeli-okuma'"></JobGolgeliOkuma>
    <JobKelimeAvi v-if="start == true && $route.params.type == 'job-kelime-avi'"></JobKelimeAvi>
    <JobSerbestOkuma v-if="start == true && $route.params.type == 'job-golgeli-okuma'"></JobSerbestOkuma>
    <div id="info" v-if="start == false" style="
        width: 700px;
        margin: 0 auto;
        background-color: white;
        padding: 50px 20px;
        margin-top: 100px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
        padding-bottom: 100px;
      ">
      <div>
        <div class="col-md-12">
          <h1 class="dark-inverted text-center" style="font-size: 28px; font-weight: bold">
            {{ $t("modules." + getActiveModule.title) }}
          </h1>
          <h1 class="dark-inverted text-center" style="font-size: 18px">
            {{ $t("cats." + getActiveModule.category) }}
          </h1>
          <h1 class="dark-inverted mt-5" style="
              font-size: 18px;
              font-family: Poppins;
              line-height: 28px;
              font-weight: 500;
              text-align: center;
            " v-html="getActiveModule['description_' + $i18n.locale]"></h1>
          <div style="
              position: absolute;
              bottom: 0px;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              left: 0px;
              padding: 10px 15px;
              background: whitesmoke;
            ">
            <p style="display: flex; flex: 1">
              {{ $t("coursedetail.zoom") }}
            </p>
            <div>
              <div style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                ">
                <a @click="$store.state.scale -= 0.05" href="javascript:;" style="
                    color: rgb(28 68 156);
                    margin-left: 10px;
                    margin-right: 10px;
                    font-size: 20px;
                  ">
                  <i class="fas fa-search-minus"></i>
                </a>

                <a @click="$store.state.scale += 0.05" href="javascript:;" style="
                    color: rgb(28 68 156);
                    margin-left: 10px;
                    margin-right: 10px;
                    font-size: 20px;
                  ">
                  <i class="fas fa-search-plus"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @click="startExercise" style="
          width: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #1c449c;
          border-radius: 25px;
          color: white;
          font-size: 18px;
          margin: 0 auto;
          box-shadow: 0 0 0 #1c449c;
          animation: pulseee 2s infinite;
          padding: 8px 0px;
          margin-top: 30px;
        ">
        {{ $t("edetail.start") }}
      </div>
    </div>
  </div>
</template>

<script>
import GozEsnetme from "@/components/modules/GozEsnetme";
import IkiliUcluBlok from "@/components/modules/IkiliUcluBlok";
import SinavIkiliUcluBlok from "@/components/modules/SinavIkiliUcluBlok";
import EsnekGormeAlani from "@/components/modules/EsnekGormeAlani";
import GozEsnekligi from "@/components/modules/GozEsnekligi";
import GozRitim from "@/components/modules/GozeRitim";
import AcilanNesnelerYatay from "@/components/modules/AcilanNesnelerYatay";
import KareGormeAlani from "@/components/modules/KareGormeAlani";
import HarfSayma from "@/components/modules/HarfSayma";
import FarkliOlan from "@/components/modules/FarkliOlan";
import KelimeAvi from "@/components/modules/KelimeAvi";
import CokluFokus from "@/components/modules/CokluFokus";
import CevreFokus from "@/components/modules/CevreFokus";
import BlokOkuma from "@/components/modules/BlokOkuma";
import GolgeliOkuma from "@/components/modules/GolgeliOkuma";
import GrupOkuma from "@/components/modules/GrupOkuma";
import Takistoskop from "@/components/modules/Takistoskop";
import ZikZak from "@/components/modules/ZikZak";
import BenzerKelimeler from "@/components/modules/BenzerKelimeler";
import DuzeltBakalim from "@/components/modules/DuzeltBakalim";
import Siralama from "@/components/modules/Siralama";
import EsAnlamlilar from "@/components/modules/EsAnlamlilar";
import HangisiBuyuk from "@/components/modules/HangisiBuyuk";
import HizliSecim from "@/components/modules/HizliSecim";
import KostebegiYakala from "@/components/modules/KostebegiYakala";
import HafizandaTut from "@/components/modules/HafizandaTut";
import HafizaKareleri from "@/components/modules/HafizaKareleri";
import SpeedTest from "@/components/modules/SpeedTest";
import DuzeltBakalimKids from "@/components/modules/DuzeltBakalimKids";
import Siir from "@/pages/Siir";
import SiirWord from "@/pages/SiirWord";
import Tekerleme from "@/pages/Tekerleme";
import ForChild from "@/pages/ForKids";
import ForChildWord from "@/pages/ForKidsWord";
import TekerlemeWord from "@/pages/TekerlemeWord";
import Heceleme from "@/pages/Heceleme";
import MetinOkuma from "@/components/modules/MetinOkuma";
import KelimeEgzersizi from "@/components/modules/KelimeEgzersizi";
import Bavul from "@/components/modules/Bavul";
import KarTanesi from "@/components/modules/KarTanesi";
import Tangram from "@/components/modules/Tangram";

import HarfSaymaDev from "@/components/modules/HarfSaymaDev";
import HizliSecimTriple from "@/components/modules/HizliSecimTriple";
import SoruEgzersizi from "@/components/modules/SoruEgzersizi";
import SinavGolgeliOkuma from "@/components/modules/SinavGolgeliOkuma";
import SinavGozRitim from "@/components/modules/SinavGozRitim";

import SinavKelimeAvi from "@/components/modules/SinavKelimeAvi";
import SinavSerbestOkuma from "@/components/modules/SinavSerbestOkuma";
import OdakOkuma from "../components/modules/OdakOkuma.vue";

import JobGozRitim from "@/components/modules/JobGozRitim";
import JobGolgeliOkuma from "@/components/modules/JobGolgeliOkuma";
import JobKelimeAvi from "@/components/modules/JobKelimeAvi";
import JobSerbestOkuma from "@/components/modules/JobSerbestOkuma";

export default {
  components: {
    JobSerbestOkuma,
    JobKelimeAvi,
    SinavSerbestOkuma,
    SinavKelimeAvi,
    SinavGozRitim,
    SinavIkiliUcluBlok,
    SinavGolgeliOkuma,
    SoruEgzersizi,
    HizliSecimTriple,
    KarTanesi,
    Bavul,
    KelimeEgzersizi,
    HangisiBuyuk,
    GozEsnetme,
    IkiliUcluBlok,
    EsnekGormeAlani,
    GozEsnekligi,
    GozRitim,
    AcilanNesnelerYatay,
    KareGormeAlani,
    HarfSayma,
    FarkliOlan,
    KelimeAvi,
    CokluFokus,
    CevreFokus,
    BlokOkuma,
    GolgeliOkuma,
    GrupOkuma,
    Takistoskop,
    ZikZak,
    BenzerKelimeler,
    DuzeltBakalim,
    Siralama,
    EsAnlamlilar,
    HizliSecim,
    KostebegiYakala,
    HafizandaTut,
    HafizaKareleri,
    SpeedTest,
    Siir,
    Tekerleme,
    ForChild,
    DuzeltBakalimKids,
    ForChildWord,
    TekerlemeWord,
    SiirWord,
    Heceleme,
    MetinOkuma,
    Tangram,
    HarfSaymaDev,
    OdakOkuma,
    JobGozRitim,
    JobGolgeliOkuma
  },
  name: "ExerciseDetail",
  data() {
    return {
      start: false,
    };
  },
  methods: {
    fullScreen() {
      var isInFullScreen =
        (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement &&
          document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement &&
          document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null);

      var docElm = document.documentElement;
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        }
      } else {
        return;
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    startExercise() {
      this.fullScreen();
      this.start = true;
    },
  },
  computed: {
    getActiveModule() {
      var x = this.$store.state.modules.find(
        (k) => k.slug == this.$route.params.type
      );
      return x;
    },
  },
};
</script>

<style>
@-webkit-keyframes pulseee {
  0% {
    -webkit-box-shadow: 0 0 0 0 #1c449c;
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }

  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}

@keyframes pulseee {
  0% {
    -moz-box-shadow: 0 0 0 0 #1c449c;
    box-shadow: 0 0 0 0 #1c449c;
  }

  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }

  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}
</style>

<style lang="less">
#info {
  p {
    color: #767676;

    strong {
      color: #767676;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/ExerciseDetail.vue